import { Button } from 'react-bootstrap';
import { ReactComponent as AddCircleIcon } from 'assets/images/add-circle.svg';
import { ReactComponent as CancelCircleIcon } from 'assets/images/cancel-circle.svg';
import { ReactComponent as EditIcon } from 'assets/images/edit.svg';
import { Tooltip } from '@mui/material';

interface SubtaskActionsPropss {
  disabled?: boolean;
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
}

const SubtaskActions = ({
  disabled,
  onAdd,
  onEdit,
  onDelete,
}: SubtaskActionsPropss) => {
  return !disabled ? (
    <div className="d-flex flex-wrap">
      {onAdd && (
        <Button
          size="sm"
          variant="link"
          className="p-1 text-muted"
          onClick={onAdd}
        >
          <Tooltip title="Add" arrow>
            <AddCircleIcon width={18} />
          </Tooltip>
        </Button>
      )}
      <Button
        size="sm"
        variant="link"
        className="p-1 text-muted"
        onClick={onDelete}
      >
        <Tooltip title="Delete" arrow>
          <CancelCircleIcon width="18" />
        </Tooltip>
      </Button>
      <Button
        size="sm"
        variant="link"
        className="p-1 text-muted"
        onClick={onEdit}
      >
        <Tooltip title="Edit" arrow>
          <EditIcon width="18" />
        </Tooltip>
      </Button>
    </div>
  ) : null;
};

export default SubtaskActions;
